import ModalComponent from '../../../components/ModalComponent';
import { DeviceDiscriminator } from '../../../services/Devices/types';
import React, { useEffect, useState } from 'react';
import { IPaginationParams } from '../../../services/types';
import {
  EVENT_ENDPOINT,
  getStreamByEndpointAsync,
} from '../../../services/Events';
import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { useGetAllEventsCountByDeviceIdAsync } from '../../../services/Events/hooks/useMutation';
import ImageSimpleColumnComponent from '../../../components/ImageSimpleColumnComponent';
import ImageModalComponent from '../../../components/ImageModalComponent';

interface EventListByDeviceModalProps {
  isOpen: boolean;
  onClose: () => void;
  deviceName?: string;
  deviceId?: number;
}

const EventListByDeviceModal = ({
  deviceName,
  isOpen,
  onClose,
  deviceId,
}: EventListByDeviceModalProps) => {
  const [eventsCount, setEventsCount] = useState(0);
  const [events, setEvents] = useState([]);
  const [isVisibleImageModal, setIsVisibleImageModal] = useState(false);
  const [imageUrlToRender, setImageUrlToRender] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });

  const { mutateAsync: mutateGetAllEventsCountByDeviceIdAsync } =
    useGetAllEventsCountByDeviceIdAsync();

  const columns: IColumnProps[] = [
    { label: 'Descrição', id: 'description' },
    {
      id: 'image',
      label: 'Imagem',
      width: '15%',
      align: 'center',
      render: (url) => {
        return (
          <ImageSimpleColumnComponent
            url={url}
            onClick={() => handleOpenImageModal(url)}
          />
        );
      },
    },
    {
      label: 'Horário',
      id: 'createdAt',
      width: '0',
      render: (value) => {
        return <>{new Date(value).toLocaleString('pt-BR')}</>;
      },
    },
  ];

  const handleOpenImageModal = (imageUrl: string) => {
    setIsVisibleImageModal(true);
    setImageUrlToRender(imageUrl);
  };

  useEffect(() => {
    if (!deviceId) return;

    // Sem isso, ao trocar de dispositivo (ou o efeito rodar de novo) o socket anterior
    // ficava aberto pra sempre — mensagens atrasadas dele (ou o auto-reconnect embutido em
    // getStreamByEndpointAsync) continuavam chamando setEvents e sobrescreviam a tela com
    // os eventos do dispositivo errado, mesmo com o modal já mostrando outro deviceId.
    let isActive = true;
    let activeSocket: WebSocket | null = null;

    getStreamByEndpointAsync(
      `${EVENT_ENDPOINT}/${deviceId}`,
      (data) => {
        if (isActive) setEvents(data);
      },
      pagination,
      undefined,
      setIsLoading,
      undefined,
      false,
      undefined,
    ).then((socket) => {
      if (!isActive) {
        if (socket) (socket as any)._isIntentionalClose = true;
        socket?.close();
        return;
      }
      activeSocket = socket;
    });

    mutateGetAllEventsCountByDeviceIdAsync(deviceId).then((count) => {
      if (isActive) setEventsCount(count);
    });

    return () => {
      isActive = false;
      if (activeSocket) (activeSocket as any)._isIntentionalClose = true;
      activeSocket?.close();
    };
  }, [deviceId, pagination]);
  return (
    <ModalComponent isOpen={isOpen} onClose={onClose} title={'Eventos'}>
      <TableComponent
        title={'Eventos do dispositivo ' + deviceName}
        rows={events}
        onChangePageOrRowsPerPage={setPagination}
        columns={columns}
        isLoading={isLoading}
        totalCount={eventsCount}
      />

      <ImageModalComponent
        isOpen={isVisibleImageModal}
        handleClose={() => setIsVisibleImageModal(false)}
        imageUrl={imageUrlToRender}
      />
    </ModalComponent>
  );
};

export default EventListByDeviceModal;
